import { useCallback, useRef } from 'react';
import { CodiceServizioSerivizioPianoEccellenza } from '../../domain/servizi/servizi';
import { loadServizioPerUfficio } from '../../Api/nuovaPratica';

function isServizioDaMostrareNellaLista(servizio) {
    if (`${servizio.IdServizio}` === window.IdServizioPrenotazioneRichiamata) {
        return false; // non visualizzo prenota richiamata
    }

    if (`${servizio.IdServizio}` === window.IdServizioPrenotaAssistenzaAttivazione) {
        return false; // non visualizzo prenota assistenza attivazione
    }

    if (servizio.Alias === CodiceServizioSerivizioPianoEccellenza) {
        return false; // non visualizzo piano eccellenza
    }

    return true;
}

export default function useServiziListaQuesiti(baseUrl, ufficioSelezionato) {
    const serviziRef = useRef();

    const getServizi = useCallback(() => {
        if (serviziRef.current) return Promise.resolve(serviziRef.current);
        return loadServizioPerUfficio(baseUrl, ufficioSelezionato)
            .then((servizi) => servizi.filter(isServizioDaMostrareNellaLista))
            .then((servizi) => {
                serviziRef.current = servizi;
                return servizi;
            });
    }, [baseUrl, ufficioSelezionato]);

    return getServizi;
}
